import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid, Button, IconButton, Link } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import logo from "../images/logo.png";
import facebook from "../images/facebook.svg";
import twitter from "../images/twitter.svg";
import instagram from "../images/insta.svg";
import youtube from "../images/youtube.svg";
import tiktok from "../images/tiktok.svg";
import mail from "../images/mail.svg";
import pinterest from "../images/pinterest.svg";
import linkedIn from "../images/linkedIn.svg";
import Playstore from "../images/playstore.svg";
import AppStore from "../images/appStore.svg";
import {
    containerStyles,
    mainBoxStyles,
    logoBoxStyles,
    logoImageStyles,
    logoTextStyles,
    contactTextStyles,
    socialIconStyles,
    sectionTitleStyles,
    linkTextStyles,
    buttonStyles,
    boxStyles,
    typographyStylesGetItOn,
    typographyStylesGooglePlay,
    footerBarStyles,
    footerTextStyles,
} from "../css/footerStyles.js"; // Import all styles from footerStyles.js

// Function to scroll to the top of the page
const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

export default function Home() {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <Container maxWidth={false} disableGutters sx={containerStyles}>
            <Box sx={mainBoxStyles}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Grid container item lg={8} md={8} sm={12} xs={12}>
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                <Box sx={logoBoxStyles}>
                                    <Box component="img" src={logo} alt="logo" loading="lazy" sx={logoImageStyles} />
                                    <Typography variant="h4" sx={logoTextStyles}>AMBD</Typography>
                                </Box>
                                <Box sx={{ ml: { xs: 4 } }}>
                                    <Typography variant="body1" sx={{ ...contactTextStyles, mt: 4 }}>
                                        Email: info@ambd.info
                                    </Typography>
                                    <Box sx={{ mt: 2, textAlign: 'start' }}>
                                        <a href="https://www.facebook.com/ambdinfo/" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={facebook}
                                                alt="facebook"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://www.youtube.com/@ambd-info" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={youtube}
                                                alt="youtube"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://www.tiktok.com/@ambdinfo" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={tiktok}
                                                alt="tiktok"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://www.twitter.com/ambdinfo/" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={twitter}
                                                alt="twitter"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="mailto:info@ambd.info" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={mail}
                                                alt="mail"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://au.pinterest.com/ambdinfo/" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={pinterest}
                                                alt="pinterest"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://www.instagram.com/ambdinfo/" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={instagram}
                                                alt="instagram"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                        <a href="https://www.linkedin.com/company/ambdinfo" target="_blank" rel="noopener noreferrer">
                                            <Box
                                                component="img"
                                                src={linkedIn}
                                                alt="linkedIn"
                                                loading="lazy"
                                                sx={{ ...socialIconStyles, cursor: 'pointer', mb: 1 }}
                                            />
                                        </a>
                                    </Box>


                                </Box>
                            </Grid>
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                <Box sx={{ ml: { xs: 4 }, mt: { xs: 4, lg: 0 } }}>
                                    <Typography variant="h4" sx={sectionTitleStyles}>Useful Links</Typography>
                                </Box>
                                <Box sx={{ mt: 3, ml: { xs: 4 } }}>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("Home")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Home
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("Features")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Features
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("Pages")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Pages
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("Pricing")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Pricing
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("Compare_package")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        Compare Package
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={linkTextStyles}
                                        onClick={() => scrollToSection("FQA")}
                                        style={{ cursor: "pointer" }}
                                    >
                                        FAQs
                                    </Typography>
                                </Box>

                            </Grid>
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                                <Box sx={{ ml: { xs: 4 }, mt: { xs: 4, lg: 0 } }}>
                                    <Typography variant="h4" sx={sectionTitleStyles}>Let’s Try Out</Typography>
                                </Box>
                                <Box sx={{ ml: { xs: 4 }, mt: 4 }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            ...buttonStyles,
                                            width: '230px', // Ensure it takes full width on small screens
                                        }}
                                        startIcon={
                                            <Box
                                                component="img"
                                                sx={{ width: 40, height: 40, display: "inline-block" }}
                                                alt="AppStore"
                                                src={AppStore}
                                            />
                                        }
                                        onClick={() => window.open("https://apps.apple.com/pk/app/ambd/id6503895917", "_blank")}
                                    >
                                        <Box sx={boxStyles}>
                                            <Typography sx={typographyStylesGetItOn}>
                                                iphone app on
                                            </Typography>
                                            <Typography sx={typographyStylesGooglePlay}>
                                                App Store
                                            </Typography>
                                        </Box>
                                    </Button>
                                </Box>
                                <Box sx={{ ml: { xs: 4 }, mt: 4 }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            ...buttonStyles,
                                            width: '230px', // Ensure it takes full width on small screens
                                        }}
                                        startIcon={
                                            <Box
                                                component="img"
                                                sx={{ height: 40, display: "inline-block" }}
                                                alt="Playstore"
                                                src={Playstore}
                                            />
                                        }
                                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.ambd.ambd&pli=1", "_blank")}
                                    >
                                        <Box sx={boxStyles}>
                                            <Typography sx={typographyStylesGetItOn}>
                                                Android app on
                                            </Typography>
                                            <Typography sx={typographyStylesGooglePlay}>
                                                Google Play
                                            </Typography>
                                        </Box>
                                    </Button>

                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                {/* Scroll to Top Icon */}
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "end", p: 0 }}>
                    <IconButton
                        onClick={scrollToTop}
                        sx={{
                            background: "linear-gradient(135deg, #0D0D0D, #2A2A2A)", // Dark gradient
                            color: "#FFFFFF",
                            mr: 2,
                            mb: 2,
                            borderRadius: "50%", // Makes it circular
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)", // Soft shadow for depth
                            transition: "transform 0.2s ease-in-out", // Hover effect
                            "&:hover": {
                                background: "linear-gradient(135deg, #2A2A2A, #0D0D0D)", // Slight color change on hover
                                transform: "scale(1.1)", // Slightly larger on hover
                            },
                            width: "56px",
                            height: "56px",
                        }}
                    >
                        <ArrowUpwardIcon fontSize="large" />
                    </IconButton>
                </Box>

                <Box>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins, Arial, sans-serif',
                            fontSize: '22px',
                            fontWeight: 700,
                            color: 'white',
                            px: { xs: 2, sm: 2, md: 8, lg: 8 },
                            pb: 3,
                        }}
                    >
                        Please note{' '}
                        <span
                            style={{
                                fontFamily: 'Poppins, Arial, sans-serif',
                                fontSize: '16px',
                                fontWeight: 600,
                            }}
                        >
                            - AMBD will not be held accountable or responsible for the validation or authenticity of any, person, profile, or transaction. This is an initiative for Muslims, hence you are expected, encouraged, and advised to follow Sunnah, Sharia (شريعة), or seek advice of a qualified religious scholar (مفتي)._ before engaging in any business activities.Debates, Discussions, Casual comments, or Unrelated Posts, are not allowed. The Admin may first issue a warning and then remove such person from the platform.
                        </span>
                    </Typography>
                </Box>
            </Box>



            <Box sx={footerBarStyles}>
                <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Grid container item lg={8} md={8} sm={12} xs={12} sx={{ display: "flex", justifyContent: "between", alignItems: "center" }}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Typography variant="body1" sx={{ ...footerTextStyles, display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'center', md: 'start', lg: 'start' } }}>
                                © Copyrights 2022. All rights reserved.
                            </Typography>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Typography variant="body1" sx={{ ...footerTextStyles, display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'center', md: 'end', lg: 'end' } }}>
                                Design & developed by
                                <Link href="#" underline="always" sx={{ ml: 1, color: '#FFFFFF' }}>Appistan</Link>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
